// assets/wearwho-fundraising-bar.js
// Animates [data-ww-progress] bars to their data-percent value on scroll into view.

(function () {
  'use strict';

  function animateBar(bar) {
    var target = parseFloat(bar.dataset.percent) || 0;
    var fill = bar.querySelector('.ww-progress__fill');
    if (!fill) return;
    var start = null;
    var duration = 1200;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      fill.style.width = (eased * target) + '%';
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var bars = document.querySelectorAll('[data-ww-progress]');
  if (!bars.length) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateBar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    bars.forEach(function (bar) { observer.observe(bar); });
  } else {
    bars.forEach(animateBar);
  }
})();
